import { useNavigationCapabilities } from '../hooks/useNavigationCapabilities';

// This is because hooks in React can't run conditionally (behind the gate) but components can
export const Capabilities = () => {
  useNavigationCapabilities();
  return null;
};